var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{ref:"root",style:(`
      white-space: pre-wrap;
      margin: 0;
      ${_vm.lines > 0 ? `
          display: -webkit-box; 
          -webkit-line-clamp: ${_vm.lines}; 
          -webkit-box-orient: vertical;
          overflow: hidden;
        ` : ''}
    `)},[_vm._l((_vm.items),function(item,i){return [(typeof item === 'string')?_c('span',{key:i},[_vm._v(_vm._s(item))]):(item.type === 'member')?_c('router-link',{key:i,staticClass:"fb-link",attrs:{"to":item.to}},[_vm._v(_vm._s(item.text))]):(item.type === 'hashtag')?_c('span',{key:i,staticClass:"fb-link"},[_vm._v(_vm._s(item.text))]):_vm._e()]})],2),(_vm.lineClamped)?_c('p',{staticClass:"ma-0 subtitle-1 primary--text",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.expanded = !_vm.expanded}}},[_vm._v("See "+_vm._s(_vm.expanded ? 'Less' : 'More'))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }